export default __webpack_public_path__ + "static/media/logo.52f0ca5a.svg";